<template>
  <section :class="cssClass">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 rc-col-text rc-col-max-width">
          <h2 v-html="$t('statics.about.section4.title')"></h2>
          <p class="rc-intro" v-html="$t('statics.about.section4.text.1')"></p>
          <p class="rc-intro" v-html="$t('statics.about.section4.text.2')"></p>
        </div>
        <div class="col-md-6 rc-col-text rc-col-max-width">
          <h2 v-html="$t('statics.about.section4.list.title')"></h2>
          <ul class="rc-list-bullet mb-0">
            <li v-html="$t('statics.about.section4.list.1')"></li>
            <li v-html="$t('statics.about.section4.list.2')"></li>
            <li v-html="$t('statics.about.section4.list.3')"></li>
            <li v-html="$t('statics.about.section4.list.4')"></li>
            <li v-html="$t('statics.about.section4.list.5')"></li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col text-center rc-col-text pt-0">
          <router-link :to="toMarketSubscription" class="btn btn-dark btn-lg my-0">{{
            $t('statics.about.section4.cta')
          }}</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { navMixin } from '#/routes/mixins'

export default {
  name: 'RcInfoSubscription',
  props: {
    cssClass: {
      type: String,
      default: ''
    }
  },

  mixins: [navMixin]
}
</script>

<style scoped></style>
